import { useSelector } from 'react-redux';
import get from 'lodash/get';

/**
 * Render checker if we have a given config
 * @children children to render
 * @subject value to check on config
 * @selector selector to check config path
 * @returns Children component or no component(null) at all
 */
const ConfigRenderer = ({ children, subject, selector }) => {
  const config = useSelector((state) => get(state.config?.settings?.core, selector));

  // Force config and subject in to arrays
  const configAsArray = Array.isArray(config) ? config : [config];
  const subjectAsArray = Array.isArray(subject) ? subject : [subject];

  //Check if they do intercept, resulting array should have intercepting subjects
  const arrayIntersections = configAsArray.filter((subject) => subjectAsArray.includes(subject));

  //If they do intercept or if subject and selector are not provided, it should render children
  const allow = arrayIntersections.length > 0 || (subject === undefined && selector === undefined);

  return allow ? children : null;
};

export { ConfigRenderer };
